import React, { useState, useEffect, useRef, use } from 'react';
import { Col, Form, Row, Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useLogin } from '../../context/LoginContext';
import { TopMenu, Input, PopupModel } from '../shared';
import { GETSTATE, GETDISTRICT, REGISTERUSER, SENDOTP, VERIFYOTP } from '../../utils/ApiEndPoint';
import apiClient from '../../api/apiClient';
import { organisation, institutions, getOrganisationLabel, IC, getLabelbyValue, isStrongPassword, lmsConfig } from '../../utils/utils';
import { isNotEmpty, isValidNumber, isValidMobileNumber, hasGraterthenLength, hasSpecificLength } from '../../utils/validation';
import { Check } from '../../utils/FontIcon';


function Registeration() {
    const navigate = useNavigate();
    const { isLoggedIn } = useLogin();
    const [form, setForm] = useState({
        firstname: '',
        lastname: '',
        mobileno: "",
        emailid: '',
        state: '',
        district: '',
        organization: '',
        institution: '',
        insurancecompany: '',
        otherorganization: '',
        otherinstitution: '',
        universitycollege: '',
        role: '',
        password: "",
        confirmpassword: "",
        isMobileVerified: false,
    });
    const [stateList, setStateList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [errors, setErrors] = useState({});
    const [registrationStatus, setRegistrationStatus] = useState({
        status: false,
        message: ''
    });
    const [popupData, setPopupData] = useState({
        show: false,
        title: '',
        type: '',
        selectedItem: { msg: '' },
    });
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [waitForResponse, setWaitForResponse] = useState(false);

    const [timer, setTimer] = useState(lmsConfig.otpWaitTime);
    useEffect(() => {
        apiClient.get(GETSTATE)
            .then((response) => {
                if (response.status === 200) {
                    setStateList(response.data.states);
                } else {
                    console.log('state list not found')
                }
            }).catch((error) => {
                console.log("🚀 krishna  ~ error:", error);
            }).finally(() => {
                console.log('krishna finally')
            });
    }, [])
    useEffect(() => {
        if (isLoggedIn) {
            navigate('/home');
        }
    }, [isLoggedIn]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'mobileno' && (!isValidNumber(value) || hasGraterthenLength(value, 10))) {
            return;
        }
        setForm(prev => {
            const next = {
                ...prev,
                [name]: value,
                ...(name === 'mobileno' ? { isMobileVerified: false } : {})
            };
            if (name === 'organization' && value !== '01') {
                next.institution = '';
            }
            return next;
        });
        setErrors((prev) => ({ ...prev, [name]: '' }));
        if (name === 'state') {
            getDisctrict(value);
        }
    };
    const handleLogIn = (e) => {
        e.preventDefault();
        navigate('/login');
    };
    const getDisctrict = (stateId) => {
        apiClient.get(`${GETDISTRICT}/state/${stateId}`,)
            .then((response) => {
                if (response.status === 200) {
                    setDistrictList(response.data.districts);
                } else {
                    console.log('state list not found')
                }
            }).catch((error) => {
                console.log("🚀 krishna  ~ error:", error);
            }).finally(() => {
                console.log('krishna finally')
            });
    }
    const validateForm = () => {
        const newErrors = {};
        if (!isNotEmpty(form.firstname)) newErrors.firstname = 'First name is required';
        if (!isNotEmpty(form.lastname)) newErrors.lastname = 'Last name is required';
        if (!isNotEmpty(form.mobileno)) newErrors.mobileno = 'Mobile number is required';
        if (isNotEmpty(form.mobileno) && isValidMobileNumber(form.mobileno) && !hasSpecificLength(form.mobileno, 10)) newErrors.mobileno = 'Mobile number must be 10 digits';
        if (isNotEmpty(form.mobileno) && isValidMobileNumber(form.mobileno) && hasSpecificLength(form.mobileno, 10) && !form.isMobileVerified) newErrors.mobileno = 'Please verify mobile number';
        // if (form.emailid && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.emailid)) newErrors.emailid = 'Please enter valid email id';
        if (!isNotEmpty(form.password)) newErrors.password = 'Password is required';
        if (isNotEmpty(form.password) && !isStrongPassword(form.password)) newErrors.password = 'Invalid password format';
        if (!isNotEmpty(form.confirmpassword)) newErrors.confirmpassword = 'Confirm password is required';
        if (isNotEmpty(form.password) && isNotEmpty(form.confirmpassword) && form.password !== form.confirmpassword) newErrors.confirmpassword = 'Passwords do not match';
        if (!isNotEmpty(form.state)) newErrors.state = 'State is required';
        if (!isNotEmpty(form.district)) newErrors.district = 'District is required';
        if (!isNotEmpty(form.organization)) newErrors.organization = 'Organization is required';
        if (form.organization === '01' && !isNotEmpty(form.institution)) newErrors.institution = 'Institution is required';
        else if (form.organization === '11' && !isNotEmpty(form.insurancecompany)) newErrors.insurancecompany = 'Insurance Company is required';
        else if ((form.organization === '02' ||
            form.organization === '03' ||
            form.organization === '04' ||
            form.organization === '10') && !isNotEmpty(form.otherorganization)) newErrors.otherorganization = `Please enter ${getOrganisationLabel(form.organization)} name`;
        if (form.institution === '07' && !isNotEmpty(form.otherinstitution)) newErrors.otherinstitution = 'Please enter institution name';
        else if (form.institution === '08' && !isNotEmpty(form.universitycollege)) newErrors.universitycollege = 'Please enter University/College name';
        if (!isNotEmpty(form.role)) newErrors.role = 'Designation is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const requestRegistration = (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        setWaitForResponse(true);
        const {
            firstname, lastname, mobileno, password, emailid,
            state, district, organization, otherorganization,
            institution, otherinstitution, insurancecompany,
            universitycollege, role
        } = form;

        const payload = {
            name: `${(firstname || '').trim()} ${(lastname || '').trim()}`.trim(),
            mobile: mobileno,
            password,
            ...(emailid?.trim() && { email: emailid.trim() }),
            state: getLabelbyValue(stateList, state, 'state_code', 'state_name'),
            stateCode: state,
            district: getLabelbyValue(districtList, district, 'district_code', 'district_name'),
            districtCode: district,
            organisation: getLabelbyValue(organisation, organization, 'value', 'label'),
            ...((['02', '03', '04', '10'].includes(organization) && otherorganization?.trim()) && { organisationName: otherorganization.trim() }),
            ...(organization === '01' && { institution: getLabelbyValue(institutions, institution, 'value', 'label') }),
            ...(organization === '01' && institution === '07' && { otherInstitutionName: otherinstitution.trim() }),
            ...(organization === '01' && institution === '08' && { collegeUniversityName: universitycollege.trim() }),
            ...(organization === '11' && { insuranceCompanyName: getLabelbyValue(IC, insurancecompany, 'value', 'label') }),

            ...(role?.trim() && {
                roles: [{
                    pmfbyRoleId: '',
                    roleName: role.trim(),
                    displayUserType: role.trim()
                }]
            })


        };
        apiClient.post(REGISTERUSER, payload)
            .then(response => {
                console.log("🚀 krishna  ~ response:", response);
                if (response.status === 200) {
                    setRegistrationStatus({
                        status: true,
                        message: form.firstname + " " + form.lastname + ' your registration has been successfully completed. You can now log in to your account.'
                    });
                    resetForm();
                    setTimeout(() => {
                        navigate('/login')
                    }, 10000);
                } else {
                    setRegistrationStatus({
                        status: false,
                        message: response.data?.error || 'Registration failed. Please try again.'
                    });
                }
            }).catch(error => {
                setRegistrationStatus({
                    status: false,
                    message: `${error?.data?.error}${error?.data?.details ?', '+ error.data.details : ''}` || 'Registration failed. Please try again.'
                });
            }).finally(() => {
                console.log('krishna finally requestRegistration')
                setWaitForResponse(false);
            })
    }
    const hidePupop = () => {
        setPopupData({
            show: false,
            title: '',
            type: '',
            selectedItem: { msg: '' },
        });
        setOtp(["", "", "", "", "", ""]);
    }
    const otpRefs = useRef([]);

    const handelOtpChange = (e) => {
        const { value } = e.target;
        const index = Number(e.target.dataset.index);
        const newOtp = [...otp];

        newOtp[index] = (value || '').replace(/\D/g, '').slice(-1);
        setOtp(newOtp);

        if (newOtp[index] && index < 5) {
            otpRefs.current[index + 1]?.focus();
        } else if (!newOtp[index] && index > 0) {
            otpRefs.current[index - 1]?.focus();
        } else {
            otpRefs.current[index]?.blur();
        }
    };
    const resetForm = () => {
        setForm({
            firstname: '',
            lastname: '',
            mobileno: "",
            emailid: '',
            state: '',
            district: '',
            organization: '',
            institution: '',
            insurancecompany: '',
            otherorganization: '',
            otherinstitution: '',
            universitycollege: '',
            role: '',
            password: "",
            confirmpassword: "",
            isMobileVerified: false,
        });
        setErrors({});
    }
    const requestOtp = (e) => {
        e.preventDefault();
        const payload = {
            'mobile': form.mobileno,
            "messageType": "LMS OTP"
        };
        apiClient.post(SENDOTP, payload)
            .then(response => {

                setPopupData({
                    show: true,
                    title: 'Verify Mobile Number',
                    type: '',
                    selectedItem: {
                        msg: ''
                    }
                });
                startCountdown();
            }).catch(error => {
                console.error("Error sending OTP:", error);
            });
    }
    const startCountdown = () => {
        setTimer(lmsConfig.otpWaitTime);
        const countdown = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer <= 1) {
                    clearInterval(countdown);
                    return 0;
                }
                return prevTimer - 1;
            });
        }, 1000);
    };
    const validateOtp = (e) => {
        e.preventDefault();
        const payload = {
            'mobile': form.mobileno,
            'otp': otp.join('')
        };
        apiClient.post(VERIFYOTP, payload)
            .then(response => {
                setForm((prev) => ({
                    ...prev,
                    isMobileVerified: true
                }));
                setErrors((prev) => ({
                    ...prev,
                    mobileno: ''
                }));
                hidePupop();
            }).catch(error => {
                setErrors((prev) => ({
                    ...prev,
                    opt: error?.data?.message || 'OTP verification failed. Please try again.'
                }));
            });
    }
    const resentOtp = (e) => {
        requestOtp(e);
    }
    return (
        <div className='add-video-bg pleft0 min-h100 pt-0'>
            <Row className='justify-content-center align-items-center '>
                <TopMenu />
                <Col lg={6} sm={12} className='text-center lms-mascotbg lms-registor-mascotbg pleft0'>
                </Col>
                <Col lg={6} sm={12} >
                    {registrationStatus.status ?
                        <div className="bg-white shadow mx-auto login-bg p-4" style={{ borderRadius: '10px 60px 60px 60px' }}>
                            <h2 className="fw-bold mb-4">Registration Successful</h2>
                            <p>{registrationStatus.message} </p>
                            <Button
                                variant="warning"
                                className="w-100 mb-3 save-btn"
                                onClick={() => navigate('/login')}
                            >
                                Go to Login
                            </Button>
                        </div>
                        :
                        <div className="bg-white shadow mx-auto login-bg" style={{ borderRadius: '10px 60px 60px 60px' }}>
                            <h2 className="fw-bold mb-4">Registration</h2>
                            <Form onSubmit={requestRegistration} autoComplete="off">
                                <Row>
                                    <Col md={6} sm={12} className='mb-3'>
                                        <Input
                                            label="First Name"
                                            isMandetory={true}
                                            name="firstname"
                                            type="text"
                                            value={form.firstname}
                                            onChange={handleChange}
                                            placeholder="enter your first name"
                                            isInvalid={!!errors.firstname}
                                            feedback={errors.firstname}
                                            inlineFeedback={true}
                                            maxLength={80}
                                        />
                                    </Col>
                                    <Col md={6} sm={12} className='mb-3'>
                                        <Input
                                            label="Last Name"
                                            isMandetory={true}
                                            name="lastname"
                                            type="text"
                                            value={form.lastname}
                                            onChange={handleChange}
                                            placeholder="enter your last name"
                                            isInvalid={!!errors.lastname}
                                            feedback={errors.lastname}
                                            inlineFeedback={true}
                                            maxLength={80}
                                        />
                                    </Col>
                                    <Col md={6} sm={12} className='mb-3'>
                                        <Input
                                            label="Email Id (optional)"
                                            isMandetory={false}
                                            name="emailid"
                                            type="text"
                                            value={form.emailid}
                                            onChange={handleChange}
                                            placeholder="enter your email id"
                                            isInvalid={!!errors.emailid}
                                            feedback={errors.emailid}
                                            inlineFeedback={true}
                                            maxLength={80}
                                        />
                                    </Col>
                                    <Col md={6} sm={12} className='mb-3' style={{ position: 'relative' }}>
                                        <Input
                                            label="Mobile No"
                                            isMandetory={true}
                                            name="mobileno"
                                            type="text"
                                            value={form.mobileno}
                                            onChange={handleChange}
                                            placeholder="enter your first name"
                                            isInvalid={!!errors.mobileno}
                                            feedback={errors.mobileno}
                                            inlineFeedback={true}
                                            maxLength={10}
                                        />
                                        <Button style={{ position: 'absolute', top: '3px', right: '15px', }} onClick={requestOtp}>{form.isMobileVerified ? <Check title="Verified" /> : 'Verify'}</Button>
                                    </Col>
                                    <Col md={6} sm={12} className='mb-3'>
                                        <Input
                                            label="Password"
                                            isMandetory={true}
                                            name="password"
                                            type="password"
                                            value={form.password}
                                            onChange={handleChange}
                                            placeholder="enter your password"
                                            isInvalid={!!errors.password}
                                            feedback={errors.password}
                                            inlineFeedback={true}
                                            helperText={'Password must be minimum 8 chars long with uppercase, lowercase, number & special character (@#$%^&+=).'}
                                        />
                                    </Col>
                                    <Col md={6} sm={12} className='mb-3'>
                                        <Input
                                            label="Confirm password"
                                            isMandetory={true}
                                            name="confirmpassword"
                                            type="password"
                                            value={form.confirmpassword}
                                            onChange={handleChange}
                                            placeholder="enter confirm password"
                                            isInvalid={!!errors.confirmpassword}
                                            feedback={errors.confirmpassword}
                                            inlineFeedback={true}
                                        />
                                    </Col>
                                    <Col md={4} sm={12} className='mb-3'>
                                        <Input
                                            label="State"
                                            isMandetory={true}
                                            name="state"
                                            type="select"
                                            value={form.state}
                                            onChange={handleChange}
                                            multiple={false}
                                            isInvalid={!!errors.state}
                                            feedback={errors.state}
                                            inlineFeedback={true}
                                            options={stateList.map((item, i) => {
                                                return { value: item.state_code, label: item.state_name };
                                            })}
                                        />
                                    </Col>
                                    <Col md={4} sm={12} className='mb-3'>
                                        <Input
                                            label="District"
                                            isMandetory={true}
                                            name="district"
                                            type="select"
                                            value={form.district}
                                            onChange={handleChange}
                                            isInvalid={!!errors.district}
                                            feedback={errors.district}
                                            inlineFeedback={true}
                                            multiple={false}
                                            options={districtList.map((item, i) => {
                                                return { value: item.district_code, label: item.district_name };
                                            })}
                                        />
                                    </Col>
                                    <Col md={4} sm={12} className='mb-3'>
                                        <Input
                                            label="Organization"
                                            isMandetory={true}
                                            name="organization"
                                            type="select"
                                            value={form.organization}
                                            onChange={handleChange}
                                            isInvalid={!!errors.organization}
                                            feedback={errors.organization}
                                            inlineFeedback={true}
                                            multiple={false}
                                            options={organisation}
                                        />
                                    </Col>
                                    {form.organization == '01' ?
                                        <Col md={4} sm={12} className='mb-3'>
                                            <Input
                                                label="Institution"
                                                isMandetory={true}
                                                name="institution"
                                                type="select"
                                                value={form.institution}
                                                onChange={handleChange}
                                                isInvalid={!!errors.institution}
                                                feedback={errors.institution}
                                                inlineFeedback={true}
                                                multiple={false}
                                                options={institutions}
                                            />
                                        </Col>
                                        : null}
                                    {form.organization == '11' ?
                                        <Col md={4} sm={12} className='mb-3'>
                                            <Input
                                                label="Insurance Company"
                                                isMandetory={true}
                                                name="insurancecompany"
                                                type="select"
                                                value={form.insurancecompany}
                                                onChange={handleChange}
                                                isInvalid={!!errors.insurancecompany}
                                                feedback={errors.insurancecompany}
                                                inlineFeedback={true}
                                                multiple={false}
                                                options={IC}
                                            />
                                        </Col>
                                        : null}
                                    {form.organization === '02' ||
                                        form.organization === '03' ||
                                        form.organization === '04' ||
                                        form.organization === '10' ?
                                        <Col md={4} sm={12} className='mb-3'>
                                            <Input
                                                label={getOrganisationLabel(form.organization)} //"Others"
                                                isMandetory={true}
                                                name="otherorganization"
                                                type="text"
                                                value={form.otherorganization}
                                                onChange={handleChange}
                                                placeholder={`enter your ${getOrganisationLabel(form.organization)} name`}
                                                isInvalid={!!errors.otherorganization}
                                                feedback={errors.otherorganization}
                                                inlineFeedback={true}
                                                maxLength={20}
                                            />
                                        </Col> : null}
                                    {form.institution === '07' ?
                                        <Col md={4} sm={12} className='mb-3'>
                                            <Input
                                                label="Others"
                                                isMandetory={true}
                                                name="otherinstitution"
                                                type="text"
                                                value={form.otherinstitution}
                                                onChange={handleChange}
                                                placeholder="enter your institution name"
                                                isInvalid={!!errors.otherinstitution}
                                                feedback={errors.otherinstitution}
                                                inlineFeedback={true}
                                                maxLength={20}
                                            />
                                        </Col> : null}
                                    {form.institution === '08' ?
                                        <Col md={4} sm={12} className='mb-3'>
                                            <Input
                                                label="University/college"
                                                isMandetory={true}
                                                name="universitycollege"
                                                type="text"
                                                value={form.universitycollege}
                                                onChange={handleChange}
                                                placeholder="enter your University/college name"
                                                isInvalid={!!errors.universitycollege}
                                                feedback={errors.universitycollege}
                                                inlineFeedback={true}
                                                maxLength={20}
                                            />
                                        </Col> : null}

                                    <Col md={4} sm={12} className='mb-3'>
                                        <Input
                                            label="Designation"
                                            isMandetory={true}
                                            name="role"
                                            type="text"
                                            value={form.role}
                                            onChange={handleChange}
                                            placeholder="enter your Designation"
                                            isInvalid={!!errors.role}
                                            feedback={errors.role}
                                            inlineFeedback={true}
                                            maxLength={80}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={12}>
                                        <Button
                                            variant="warning"
                                            type="submit"
                                            title='Login'
                                            className="w-100 mb-3 save-btn"
                                            disabled={waitForResponse}
                                        >
                                            {waitForResponse ? <><Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className="me-2"
                                                variant="primary"
                                            />
                                                Wait...</> : 'Register'}

                                        </Button>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='text-center'>Already have an acount?
                                            <a className='d-inline ms-1' onClick={handleLogIn} style={{ cursor: 'pointer', color: '#f26522', textDecoration:'underline' }}>
                                                Login
                                            </a>
                                        </p>
                                    </Col>
                                    {!registrationStatus.status && registrationStatus.message != '' && (
                                        <div className="text-danger mt-2" style={{ fontSize: '14', color: '#f26522' }}>
                                            {registrationStatus.message}
                                        </div>
                                    )}
                                </Row>
                            </Form>
                        </div>
                    }
                </Col>
            </Row>
            {popupData.show ?
                <PopupModel
                    size='md'
                    showModal={popupData.show}
                    handleCloseModal={hidePupop}
                    title={popupData.title}
                    type={popupData.type}
                >
                    <div style={{ padding: '10px 0', textAlign: 'center' }}>
                        <form onSubmit={validateOtp}>
                            <p>SMS is sent to your mobile number {form.mobileno}. It is validate for 5 minutes</p>
                            <div style={{ marginBottom: '15px' }}>
                                <label htmlFor="otp-input" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Enter OTP</label>
                                {otp.map((_, index) => {
                                    return <input
                                        key={'otp' + index}
                                        type="text"
                                        maxLength={1}
                                        style={{ width: '40px', marginRight: '10px', textAlign: 'center', fontSize: '18px', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                                        tabIndex={index + 1}
                                        value={otp[index] || ""}
                                        data-index={index} ref={el => otpRefs.current[index] = el}
                                        onChange={handelOtpChange}
                                        // focused={index === 0 ? true : false}
                                    />
                                })}<br />
                            </div>
                            <Button variant="link" className='me-2' disabled={timer > 0} onClick={resentOtp}>Resend OTP {timer > 0 ? 'in ' + (Math.floor(timer / 60) + ':' + timer % 60) + ' min' : ''}</Button>
                            <Button variant="primary" type="submit" style={{ minWidth: '100px' }}>
                                Submit
                            </Button>
                            {errors.opt && <div className="text-danger mt-2">{errors.opt}</div>}
                        </form>
                    </div>
                </PopupModel> : null
            }
        </div>
    );
}

export default Registeration;
